import styled from 'styled-components/macro';

export const Container = styled.div`
  position: relative;
`;

export const List = styled.ul<{
  $isVisible?: boolean;
  $position?: 'top' | 'bottom';
  notchPosition?: 'left' | 'right';
}>`
  position: absolute;
  ${({ $position, theme }) =>
    $position === 'top' ? `bottom: ${theme.spacing.two};` : `top: ${theme.spacing.two};`}
  ${({ notchPosition }) => (notchPosition === 'left' ? 'left: 0;' : 'right: 0;')}
  z-index: ${({ theme }) => theme.zIndex.zIndex2};

  display: ${({ $isVisible }) => ($isVisible ? 'block' : 'none')};
  width: 9.75rem;
  border: 1px solid ${({ theme }) => theme.colors.black_10};
  border-radius: 4px;

  list-style-type: none;

  background-color: ${({ theme }) => theme.colors.white};
  ${({ $position }) =>
    $position === 'top'
      ? 'box-shadow: 0 -2px 10px -2px rgba(37, 40, 43, 0.2);'
      : 'box-shadow: 0 2px 10px -2px rgba(37, 40, 43, 0.2);'}

  :after {
    position: absolute;
    ${({ $position }) => ($position === 'top' ? 'bottom: -6px;' : 'top: -6px;')}
    right: 9px;

    width: 0;
    height: 0;
    border-right: 5px solid transparent;
    ${({ $position, theme }) =>
      $position === 'top'
        ? `border-top: 6px solid ${theme.colors.white};`
        : `border-bottom: 6px solid ${theme.colors.white};`}
    border-left: 5px solid transparent;

    ${({ notchPosition }) => (notchPosition === 'left' ? 'left: 9px;' : '')}

    content: '';
  }

  :before {
    position: absolute;
    ${({ $position }) => ($position === 'top' ? 'bottom: -7px;' : 'top: -7px;')}
    right: 8px;

    width: 0;
    height: 0;
    border-right: 6px solid transparent;
    ${({ $position, theme }) =>
      $position === 'top'
        ? `border-top: 6px solid ${theme.colors.black_10};`
        : `border-bottom: 6px solid ${theme.colors.black_10};`}
    border-left: 6px solid transparent;

    ${({ notchPosition }) => (notchPosition === 'left' ? 'left: 8px;' : '')}

    content: '';
  }
`;

export const ListItem = styled.li<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  padding: ${({ theme }) => theme.spacing.zero_3};

  font-size: ${({ theme }) => theme.fontSize.xxs};

  cursor: pointer;

  :hover,
  :active {
    background-color: ${({ theme }) => theme.colors.black_10};
  }

  svg {
    margin-right: ${({ theme }) => theme.spacing.zero_2};
  }

  ${({ disabled, theme }) =>
    disabled &&
    `
    color: ${theme.colors.black_20};

    > svg > path {
      stroke: ${theme.colors.black_20};
    }

  `}
`;
